<template>
	<modal
		class="customize-columns-modal"
		size="x-large"
		@close="close"
		v-if="selectedProduct"
	>
		<template slot="header">
			<div class="flex-center">
				<h3 id="title">Change History</h3>
			</div>
		</template>
		<div slot="body">
			<div class="products-list">
				<div class="row mb-4">
					<div class="col-auto">
						<div
							class="product-image"
							:style="{ backgroundImage: `url(${selectedProduct.productImage})` }">
						</div>
					</div>
					<div class="col">
						<div class="text-bold">Product Name</div>
						<div>{{ selectedProduct.name }}</div>
						<div class="text-bold mt-2">Supplier Name</div>
						<div>{{ selectedProduct.supplier }}</div>
					</div>
				</div>
				<hr />
				<div class="mb-3 d-flex justify-content-between">
					<button
						class="btn btn-default btn-sm dropdown-toggle"
						type="button"
						data-toggle="dropdown"
						aria-expanded="false"
					>
						{{ filterLabel }}
					</button>
					<div class="dropdown-menu">
						<button
							v-for="(item, idx) in filterStatics"
							:key="idx"
							type="button"
							class="dropdown-item"
							@click="assignProductTimelineFilter(idx)"
						>
							{{ item.label }}
						</button>
					</div>

					<button
						type="button"
						class="btn btn-sm btn-light"
						:class="{ 'is-loading': isExporting }"
						@click="exportProductTimeline"
					>
						<i class="material-icons">save_alt</i>
						<span class="mr-2">{{ $t('Export') }}</span>
					</button>
				</div>
				<table
					class="products-list-table table table-primary table-striped mb-0"
					:class="{ 'table-responsive': isDataExist }"
				>
					<thead>
						<tr>
							<th
								class="th-sort text-left"
								:class="{
									sortClass,
									'w-200': isDataExist,
									'w-20p': !isDataExist,
								}"
								@click="changeSortingTimeline('created_at')"
							>
								Date
							</th>
							<th class="text-left" :class="{ 'w-200': isDataExist, 'w-20p': !isDataExist }">
								Update
							</th>
							<th class="text-left" :class="{ 'w-200': isDataExist, 'w-20p': !isDataExist }">
								Before
							</th>
							<th class="text-left" :class="{ 'w-200': isDataExist, 'w-20p': !isDataExist }">
								After
							</th>
							<th class="text-left" :class="{ 'w-200': isDataExist, 'w-20p': !isDataExist }">
								Updated By
							</th>
						</tr>
					</thead>
					<tbody v-if="isFetching && timelineData.length === 0">
						<tr v-for="index in 3" :key="'timeline-loading-'+ index">
							<td>
								<shimmer :width="'100px'" />
							</td>
							<td>
								<shimmer :width="'100px'" />
							</td>
							<td>
								<shimmer :width="'100px'" />
							</td>
							<td>
								<shimmer :width="'100px'" />
							</td>
							<td>
								<shimmer :width="'100px'" />
							</td>
						</tr>
					</tbody>
					<tbody v-else-if="timelineData">
						<tr v-for="(item, idx) in timelineData" :key="`timeline-${idx}`">
							<td class="w-200" v-if="timelineData.length > 0">
								<span v-if="timelineData[idx-1] && item.created_at !== timelineData[idx-1].created_at || idx === 0">
									{{ formatDate(item.created_at) }}
								</span>
							</td>
							<td class="w-200">
								{{ item.label }}
							</td>
							<td class="w-200">
								<div v-if="item.type === 'json' || item.type === 'array'">
									<pre>{{ transform(findDifferences(item.value_before, item.value_after)) }}</pre>
								</div>
								<div v-else-if="item.key === 'description'">
									<div v-html="item.value_before"></div>
								</div>
								<div v-else>
									{{ item.value_before }}
								</div>
							</td>
							<td class="w-200">
								<div v-if="item.type === 'json' || item.type === 'array'">
									<pre>{{ transform(findDifferences(item.value_after, item.value_before)) }}</pre>
								</div>
								<div v-else-if="item.key === 'description'">
									<div v-html="item.value_after"></div>
								</div>
								<div v-else>
									{{ item.value_after }}
								</div>
							</td>
							<td class="w-200">
								{{ item.created_by }}
							</td>
						</tr>
					</tbody>
				</table>
				<div class="col-12 d-flex justify-content-center mt-3">
					<button
						v-if="isLoadMoreEnabled && timelineData.length > 0"
						type="button"
						class="btn-outline o-lg outline-primary"
						:class="{ 'is-loading': isFetching }"
						@click="loadMore"
					>
						Muat Lebih Banyak
					</button>
					<button
						v-if="timelineData.length > 0"
						type="button"
						class="btn btn-primary o-lg ml-2 d-flex align-items-center scroll-top"
						@click="scrollTo('title', -57)"
						:disabled="isFetching"
					>
						<i class="material-icons mr-2 text-bold">arrow_upward</i>
						<span class="text-bold">Kembali Ke Atas</span>
					</button>
				</div>
				<div class="list-empty table-empty w-100" v-if="timelineData.length === 0 && !isFetching">
					<i class="material-icons mr-2 va-m">error_outline</i>
					<span class="va-m">{{ $t('No data was found') }}</span>
				</div>
			</div>
		</div>
		<div slot="footer">
			<button class="btn btn-light" @click="close">Close</button>
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import Shimmer from '@/components/Shimmer.vue';
import { jsonPretty, scrollTo } from '@/lib/helper';

export default {
	name: 'ModalProductTimeline',
	components: {
		Modal,
		Shimmer,
	},
	props: {
		selectedProduct: {
			type: Object,
			default: () => {},
		},
		filterLabel: {
			type: String,
			default: 'All Update',
		},
		sortClass: {
			type: String,
			default: '',
		},
		filterStatics: {
			type: Object,
			default: () => {},
		},
		timelineData: {
			type: Array,
			default: () => [],
		},
		isExporting: {
			type: Boolean,
			default: false,
		},
		isFetching: {
			type: Boolean,
			default: false,
		},
		isLoadMoreEnabled: {
			type: Boolean,
			default: true,
		},
		user: {
			type: Object,
			default: () => {},
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		assignProductTimelineFilter(idx) {
			this.$emit('assign-filter', idx);
		},
		exportProductTimeline() {
			this.$emit('export');
		},
		changeSortingTimeline(sortBy) {
			this.$emit('change-sorting', sortBy);
		},
		loadMore() {
			this.$emit('load-more');
		},
		formatDate(dateString) {
			const format = 'DD-MM-YYYY - HH:mm';
			const timezone = this.user?.timezone ?? 'Asia/Jakarta';
			const formattedDate = this.moment
				.utc(dateString)
				.tz(timezone)
				.format(format);
			return dateString && dateString !== '' ? formattedDate : '';
		},
		scrollTo,
		jsonPretty,
		findDifferences(obj1, obj2, path = '') {
			const keys1 = Object.keys(obj1);
			const keys2 = Object.keys(obj2);
			const allKeys = new Set([...keys1, ...keys2]);

			const differences = {};

			// eslint-disable-next-line no-restricted-syntax
			for (const key of allKeys) {
				const keyName = obj1[key] && obj1[key].name ? obj1[key].name : key;
				const newPath = path ? `${path}.${keyName}` : key;
				if (obj1 === '' || !(key in obj1)) {
					differences[newPath] = '-';
				} else if (obj2 === '' || !(key in obj2)) {
					differences[newPath] = obj1[key];
				} else if (
					typeof obj1[key] === 'object'
					&& typeof obj2[key] === 'object'
					&& obj1[key] !== null
					&& obj2[key] !== null
				) {
					const nestedDifferences = this.findDifferences(obj1[key], obj2[key], newPath);
					if (nestedDifferences !== null) {
						differences[newPath] = nestedDifferences;
					}
				} else if (obj1[key] !== obj2[key]) {
					differences[newPath] = obj1[key];
				}
			}

			return Object.keys(differences).length ? differences : null;
		},
		formatKey(key) {
			if (typeof key !== 'string') {
				return key;
			}

			// Split the key by '.' and take the last part
			const splitKey = key.split('.').pop();
			// Replace underscores with spaces and capitalize each word
			return splitKey.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
		},
		formatNestedObject(obj, indent = 0) {
			let result = '';
			const indentStr = '    '.repeat(indent);

			if (typeof obj === 'object' && obj !== null) {
				// eslint-disable-next-line guard-for-in, no-restricted-syntax
				for (const key in obj) {
					if (typeof obj[key] === 'object' && obj[key] !== null) {
						result += `${indentStr}${this.formatKey(key)}\n`;
						result += this.formatNestedObject(obj[key], indent + 1);
					} else {
						const formattedKey = this.formatKey(key);
						result += `${indentStr}${formattedKey}: ${obj[key]}\n`;
					}
				}
			} else {
				result += ` : ${obj}\n`;
			}

			return result;
		},
		transform(data) {
			let output = '';

			if (typeof data === 'number' || typeof data === 'string') {
				return data;
			}

			// eslint-disable-next-line guard-for-in, no-restricted-syntax
			for (const key in data) {
				const objectKey = `${key.charAt(0).toUpperCase() + key.slice(1)}`;
				if (typeof data[key] === 'object') {
					output += `${this.formatKey(objectKey)}\n`;
					output += this.formatNestedObject(data[key], 1);
				} else {
					output += `${this.formatKey(objectKey)}`;
					output += this.formatNestedObject(data[key], 1);
				}
			}
			return output;
		},
	},
	computed: {
		isDataExist() {
			return this.timelineData.length > 0;
		},
	},
};
</script>

<style lang="scss" scoped>
.dropdown-menu {
	max-height: 300px;
	overflow-y: scroll;
}

.w-200 {
	width: 200px;
	min-width: 200px;
}

.w-20p {
	width: 20%
}

.scroll-top {
	padding: 13px;
}
</style>
